import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { DotText } from "@/v2-backoffice-client/components/dot"
import type { LayerFragment } from "@/v2-backoffice-client/layer/__types__/layer.fragment"
import LayerCategoryLayerRemoveButton from "@/v2-backoffice-client/layer/category/layer/remove/LayerCategoryLayerRemoveButton"

export type LayerCategoryLayerListItemProps = ComponentProps<"div"> & {
  layer: LayerFragment
  categoryFeatureCode: string
}

function LayerCategoryLayerListItem(props: LayerCategoryLayerListItemProps) {
  const { layer, categoryFeatureCode, className, ...divProps } = props

  return (
    <div
      className={cn(
        "flex items-center justify-between p-2 border rounded-md",
        className,
      )}
      {...divProps}
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium truncate">
            {layer.Name ?? layer.FeatureCode}
          </span>

          <DotText variant={layer.IsEnabled ? "success-1" : "destructive"}>
            {layer.IsEnabled ? "Enabled" : "Disabled"}
          </DotText>

          <DotText variant={layer.Has3dSupport ? "success-1" : "destructive"}>
            {layer.Has3dSupport ? "3D supported" : "Only 2D"}
          </DotText>
        </div>
        <div className="text-xs text-muted-foreground mt-0.5">
          {layer.FeatureCode} -- {layer.LayerTypeCode}
        </div>
      </div>

      <LayerCategoryLayerRemoveButton
        layerFeatureCode={layer.FeatureCode}
        categoryFeatureCode={categoryFeatureCode}
      />
    </div>
  )
}

export default LayerCategoryLayerListItem
